const links = document.querySelectorAll('.news-lists__link');
links.forEach(link => {
  link.addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      e.stopPropagation();
     dataLayer.push({
          'event': 'Read_More',
          'click_url': link.href
      });
  });
});

const blinks = document.querySelectorAll('.background-with-image-container_content a');
blinks.forEach(blink => {
  blink.addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      e.stopPropagation();
     dataLayer.push({
          'event': 'Read_More',
          'click_url': blink.href
      });
  });
});
